<template>  
    <div name="select-box-location-modal" class="wrapper">
        <div class="modal">
            <div class="touch" @click="onClose(selectedIndex)">

            </div>
            <div class="contents">
                <span class="title">지역 선택</span>
                <div class="select-box" style="margin-top: 30px;">                    
                    <div class="col">
                        <div :class="innerCityIndex === index ? 'button-city-active': 'button-city-inactive'" v-for="(city, index) in option" @click="selectCity(index)">
                            {{ city.cityName }}
                        </div>
                    </div>
                    <div class="col" v-if="innerCityIndex > -1">
                        <div v-for="(subcity, index) in option[innerCityIndex].subCities" @click="selectSubcity(index)">
                            <div v-if="subcity.activate" :class="innerSubcityIndex === index ? 'button-subcity-active': 'button-subcity-inactive'">
                                {{ subcity.name }}
                            </div>
                            <div v-else class="button-subcity-disable">
                                {{ subcity.name }}
                            </div>
                        </div>
                    </div>
                    <div class="col" v-else>

                    </div>
                </div>

            </div>
        </div>
    </div>
</template>

<script>
export default {
    name: 'selectBoxLoactionModal',
    props: ['option', 'selectedCityIndex', 'selectedSubcityIndex'],
    data: function()
    {
        return {
            innerCityIndex: -1,
            innerSubcityIndex: 0
        }
    },
    mounted: function()
    {
        this.innerCityIndex = this.selectedCityIndex;
        this.innerSubcityIndex = this.selectedSubcityIndex;

        document.body.style.overflow = 'hidden'; // 스크롤 비활성화
    },
    methods: {
        selectCity: function(index)
        {
            this.innerCityIndex = index;
            this.innerSubcityIndex = -1;
        },
        selectSubcity: function(index)
        {
            this.innerSubcityIndex = index;
            this.onSelect();
        },
        onClose: function()
        {   
            document.body.style.overflow = ''; // 스크롤 활성화
            this.$emit('close')
        },
        onSelect: function()
        {
            document.body.style.overflow = ''; // 스크롤 활성화
            this.$emit('select', this.innerCityIndex, this.innerSubcityIndex);
        }
    }
}
</script>

<style scoped>
    .wrapper {
        width: 100%;
        left: 0;
        top:0;
        display: flex;
        justify-content: center;
        align-items: center;
        position: fixed;
        z-index: 99;
    }
    .modal {
        position: fixed;
        background: rgba(0, 0, 0, 0.8);
        max-width: 600px;
        width: 100%;
        height: 100vh;
        z-index: 99;
        bottom: 0;
        box-sizing: border-box;
    }
    .touch {
        width: 100vw;
        height: 20vh;
    }
    .contents {
        background: #FFFFFF;
        height: 80vh;
        width: 100%;
        border-top-left-radius: 20px;
        border-top-right-radius: 20px;
        padding: 32px 20px;
        display: flex;
        flex-direction: column;
        justify-content: flex-start;
        align-items: flex-start;
        box-sizing: border-box;
        position: relative;
    }
    .select-box {
        display: flex;
        justify-content: center;
        align-items: flex-start;
        width: 100%;
    }
    .col {
        display: inline;
        flex-direction: column;
        justify-content: flex-start;
        align-items: center;
        width: 50%;
        height: calc(80vh - 122px);
        overflow-y: auto;
        overflow-x: hidden;
    }
    .title {
        color: var(--Gray-100, #1E1E1E);
        font-family: Pretendard;
        font-size: 24px;
        font-style: normal;
        font-weight: 600;
        line-height: 28px; /* 116.667% */
        letter-spacing: -0.48px;
    }
    .button-city-inactive {
        width: calc(100% - 1px);
        display: flex;
        justify-content: center;
        align-items: center;
        color: #1E1E1E;
        text-align: center;
        font-family: Pretendard;
        font-size: 18px;
        font-style: normal;
        font-weight: 500;
        line-height: 22px; /* 122.222% */
        height: 48px;
        cursor: pointer;
        border: 1px solid var(--Gray-sub-color2, #EDEEF0);
        background: var(--Gray-sub-color1, #F3F5F8);
    }
    .button-city-active {
        width: calc(100% - 1px);
        display: flex;
        justify-content: center;
        align-items: center;
        color: var(--Gray-00, #FFF);
        text-align: center;
        font-family: Pretendard;
        font-size: 18px;
        font-style: normal;
        font-weight: 500;
        line-height: 22px; /* 122.222% */
        height: 48px;
        cursor: pointer;
        border: 1px solid var(--Gray-sub-color2, #EDEEF0);
        background: var(--Gray-100, #1E1E1E);
    }
    .button-subcity-inactive {
        width: calc(100% - 1px);
        display: flex;
        justify-content: center;
        align-items: center;
        color: #1E1E1E;
        text-align: center;
        font-family: Pretendard;
        font-size: 18px;
        font-style: normal;
        font-weight: 500;
        line-height: 22px; /* 122.222% */
        height: 48px;
        cursor: pointer;
        border: 1px solid var(--Gray-sub-color2, #EDEEF0);
        background: var(--Gray-00, #FFF);
    }
    .button-subcity-active {
        width: calc(100% - 1px);
        display: flex;
        justify-content: center;
        align-items: center;
        color: var(--Gray-00, #FFF);
        text-align: center;
        font-family: Pretendard;
        font-size: 18px;
        font-style: normal;
        font-weight: 500;
        line-height: 22px; /* 122.222% */
        height: 48px;
        cursor: pointer;
        border: 1px solid var(--Gray-sub-color2, #EDEEF0);
        background: var(--Gray-100, #1E1E1E);
    }
    .button-subcity-disable {
        height: 48px;
        cursor: pointer;
        width: calc(100% - 1px);
        display: flex;
        justify-content: center;
        align-items: center;
        color: var(--gray-40-button-stroke, #D1D6DB);
        text-align: center;
        font-family: Pretendard;
        font-size: 18px;
        font-style: normal;
        font-weight: 500;
        line-height: 22px; /* 122.222% */
        border: 1px solid var(--Gray-sub-color2, #EDEEF0);
        background: var(--gray-30-stroke, #E8EAEE);
    }
</style>


// WEBPACK FOOTER //
// src/components/modals/SelectBoxLocationModal.vue